import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useJwt } from "react-jwt";
import Sidebar from "../components/Sidebar";
import { CreateBrand, GetProductStatus } from "../apiconfig/authService";
import { FaStar } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify"; // Import toastify
import "react-toastify/dist/ReactToastify.css"; // Import styles for toastify
import { RiLoaderFill } from "react-icons/ri";

function AddBrand(props) {
  const navigate = useNavigate();
  const { isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const setProductViewMessage = props.setMessage;
  const [brandname, setBrandname] = useState("");
  const [categoryStatusid, setCategoryStatusid] = useState(1);
  const [statusData, setStatusData] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleStatusIdChange = (e) => {
    setCategoryStatusid(Number(e.target.value));
  };

  const handleBrandnameChange = (e) => setBrandname(e.target.value);

  useEffect(() => {
    (async () => {
      try {
        const statusResponse = await GetProductStatus(
          localStorage.getItem("accessToken")
        );
        setStatusData(statusResponse.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      if (!brandname.trim()) {
        toast.error("Brand Name is required!");
        return;
      }
    } catch (error) {
      toast.error(error.message);
      window.scrollTo(0, 0);
      return;
    }

    try {
      setLoading(true);
      const response = await CreateBrand(
        { brandname, statusid: categoryStatusid }, // Pass categoryStatusid
        localStorage.getItem("accessToken")
      );

      if (response.status === 200) {
        setLoading(false);
        setProductViewMessage(response.data.message);
        toast.success("Brand Added Successfully!");
        navigate("/brand");
      }
    } catch (err) {
      toast.error(
        err.response?.data?.error || "An error occurred. Please try again later."
      );
      window.scrollTo(0, 0);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Add Brand Name</h1>
        </div>

        <div className="personal-info tab-pane active storetab">
          <div className="form-group col-sm-12 col-lg-12 mb-3">
            <div className="d-flex">
              <label htmlFor="brandName">Brand Name</label>
              <FaStar size={7} className="text-danger" />
            </div>
            <input
              type="text"
              value={brandname}
              onChange={handleBrandnameChange}
              className="form-control custom-input my-2"
              id="brandName"
              placeholder="Enter Brand Name"
            />
          </div>
          <div className="form-group col-sm-12 col-lg-12 mb-3">
            <label htmlFor="floatingInput">Status</label>
            <select
              className="form-select custom-input my-2"
              onChange={handleStatusIdChange}
              value={categoryStatusid}
            >
              {statusData?.map((item) => (
                <option key={item.statusid} value={item.statusid}>
                  {item.status}
                </option>
              ))}
            </select>
          </div>
          <div className="row">
            <div className="col-12" style={{ height: "40px", width: "80px" }}>
              {loading ? (
                <div
                  className="btn btn-primary loader-active save-btn"
                  style={{ height: "100%", width: "100%" }}
                >
                  <RiLoaderFill
                    size={20}
                    className="spin-animation"
                    color="white"
                  />
                </div>
              ) : (
                <button
                  type="submit"
                  disabled={loading}
                  onClick={handleSubmitClick}
                  className="btn btn-primary save-btn text-uppercase"
                  style={{ height: "100%", width: "100%" }}
                >
                  Add
                </button>
              )}
            </div>
          </div>
        </div>
        <hr />
      </div>

      {/* Toast container */}
      <ToastContainer />
    </div>
  );
}

export default AddBrand;
